import { ResultList as HeadlessResultList } from '@coveo/headless';
import { useEffect, useState, useRef, FunctionComponent } from 'react';
import { ResultLink } from './result-link.tsx';
import React from 'react';
import { Slider } from '../../../../card-slider/slider.js'

interface ResultListProps {
	controller: HeadlessResultList;
	filterBy?: {
		property: string;
		value: any;
	};
	resultsView?: string;
}

interface SliderInterface {
	querySelectors: () => Slider,
	setState: () => void,
}

export const VideoResultList: FunctionComponent< ResultListProps > = ( props ) => {
	const { controller, filterBy, resultsView } = props;
	const [ state, setState ] = useState( controller.state );
	const sliderRef = useRef<HTMLDivElement | null>( null );
	const [ slider, setSlider ] = useState<SliderInterface>();

	useEffect( () => {
		if ( sliderRef.current ) {
			setSlider( new Slider( sliderRef.current, {} ) );
		}
	}, [ sliderRef.current ] );

	useEffect( () => {
		if ( slider ) {
			slider.querySelectors();
			slider.setState();
		}
	} );

	useEffect( () => {
		controller.subscribe( () => {
			setState( controller.state );
		} );
	}, [] );

	const filteredResults = filterBy ? state.results.filter( ( result ) => result.raw[ filterBy.property ] === filterBy.value ) : state.results;

	if ( ! filteredResults.length ) {
		return null;
	}

	return (
		<div className="coveo-advanced-query__interrupt alignfull has-background has-primary-wash-background-color">
			<div className="coveo-advanced-query__interrupt-layout">
				<div className="card-slider" ref={ sliderRef }>
					<div className="card-slider__content">
						{ filteredResults.map( ( result ) => (
							<div
								key={ result.uniqueId }
								className="dyn-card"
							>
								<div className="dyn-card__wrap">
									<div className="dyn-card__media">
										<figure className="dyn-card__image">
											<ResultLink result={ result } className="dyn-card__image-link">
												{ !! result.raw[ 'imagepreview' ] ? (
													<img
														src={ result.raw[ 'imagepreview' ] as string }
														alt=""
														style={ { objectPosition: '50% 50%' } }
														className="attachment-medium size-medium"
														decoding="async"
														width={ 300 }
														height={ 300 }
													/>
												) : (
													<div className="dyn-card__image-placeholder">
														<span className="a11y">Placeholder</span>
													</div>
												) }
											</ResultLink>
										</figure>
									</div>
									<div className="dyn-card__content">
										<h2 className="dyn-card__title has-h5-variant">
											<ResultLink result={ result }>{ result.title }</ResultLink>
										</h2>
										<a href={ result.clickUri }>{ result.clickUri }</a>
										<div className="dyn-card__excerpt">{ result.excerpt }</div>
									</div>
								</div>
							</div>
						) ) }
						{ state.moreResultsAvailable && (
							<div className="card">
								<button
									type="button"
									className="coveo-advanced-query__interrupt-more"
									onClick={ () => controller.fetchMoreResults() }
								>
									Load More
								</button>
							</div>
						) }
					</div>
					<div className="card-slider__nav">
						<button
							type="button"
							className="card-slider__go card-slider__go--back"
							aria-label="Previous"
						>
							<svg
								className="svg svg--svg-assets-svg-icon-arrow-left"
								role="img"
								focusable="false"
								height="24"
								width="24"
								aria-labelledby="svg-assets-svg-icon-arrow-left-title"
							>
								<title id="svg-assets-svg-icon-arrow-left-title">Previous</title>
								<use xlinkHref="#svg-assets-svg-icon-arrow-left" />
							</svg>
						</button>
						<button
							type="button"
							className="card-slider__go card-slider__go--forward"
							aria-label="Next"
						>
							<svg
								className="svg svg--svg-assets-svg-icon-arrow-right"
								role="img"
								focusable="false"
								height="24"
								width="24"
								aria-labelledby="svg-assets-svg-icon-arrow-right-title"
							>
								<title id="svg-assets-svg-icon-arrow-right-title">Next</title>
								<use xlinkHref="#svg-assets-svg-icon-arrow-right" />
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

// usage

/**
 * ```tsx
 * const controller = buildResultList(engine);
 *
 * <ResultList controller={controller} />;
 * ```
 */
